"use strict";

module.exports = {
    "ticker__text": {
        "notifications": "Уведомлений"
    }
};